module.exports = __webpack_public_path__ + "static/media/left.c109ca4f.svg";